import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titlecaseFirstLetter',
  pure: true,
  standalone: false,
})
export class TitlecaseFirstLetterPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    const stringValue = String(value);

    if (stringValue.length === 0) {
      return stringValue;
    }

    return stringValue.charAt(0).toUpperCase() + stringValue.slice(1).toLowerCase();
  }
}
